export default __webpack_public_path__ + "static/media/33.bb62f6b3.png";